import { inject, Injectable } from '@angular/core';

import {
  OutputEmitGuard,
  PerformChecksConfig,
} from '../../canvas-elements/io-data/models/output-handler.models';
import { FormGroupOutputSynchronizer } from '../../canvas-elements/io-data/outputs/form-group-output-synchronizer';
import {
  FormStateService,
  FormValidationReportService,
} from '../../services/forms/runtime/public-api';

@Injectable({ providedIn: 'root' })
export class ButtonOutputEmitGuard implements OutputEmitGuard {
  private readonly formStateService = inject(FormStateService);
  private readonly formValidationReport = inject(FormValidationReportService);
  private readonly formGroupOutputGuard = inject(FormGroupOutputSynchronizer);

  preEmit({ event, element, validationHandler, elements }: PerformChecksConfig): boolean {
    const buttonFormData = validationHandler?.getValidationData(element.id)?.buttonFormData;
    if (event.eventType === 'click' && element.type === 'button' && buttonFormData?.formElementId) {
      if (!buttonFormData.isFormValid) {
        this.formStateService.setSubmitted(buttonFormData.formElementId);
        this.formValidationReport.showErrors(buttonFormData.messages);
        return false;
      } else if (buttonFormData.isFormPosted) {
        // form post in progress
        return false;
      } else {
        // mark form in progress
        this.formStateService.setPosted(buttonFormData.formElementId);
      }
    }

    return this.formGroupOutputGuard.checkFormGroupLikeTargets(
      event,
      element,
      validationHandler,
      elements,
      undefined,
    );
  }
}
